// AddressLine Moved to a separate file from TransportHistoriesPopup
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from "@mui/lab"
import { TTransportsHistoryInfo } from "../../../../../api/bearer-api"
import { observer } from "mobx-react-lite"
import styles from "./addressLine.module.scss";
import { useThemeMode } from "../../../../../states/contexts/theme"; // added by Bearer Web Developer
const AddressLine: React.FC<{ transportsHistory: TTransportsHistoryInfo }> = observer(({ transportsHistory }) => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <div className={styles.address_line} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Timeline classes={{ root: styles.time_line }}>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content }}>
                    <TimelineSeparator>
                        {
                            theme === 'dark' ?
                                <img src="/origin-dark.svg" alt="origin" /> :
                                <img src="/origin.png" alt="origin" />
                        }
                        <TimelineConnector className={''} />
                    </TimelineSeparator>
                    <TimelineContent className={styles.timeline_content}>{transportsHistory.origin_address}</TimelineContent>
                </TimelineItem>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content, root: styles.timelineItem_root }}>
                    <TimelineSeparator >
                        <img src="/destination.png" alt="destination" />
                    </TimelineSeparator>
                    <TimelineContent className={styles.timeline_content}>{transportsHistory.destination_address}</TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>
    )
    // modified by Bearer Web Developer end
});
export default AddressLine;
